import { render, staticRenderFns } from "./PortalApoiadoAba.vue?vue&type=template&id=9f3b8428&"
import script from "./PortalApoiadoAba.vue?vue&type=script&lang=js&"
export * from "./PortalApoiadoAba.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports